import React, { useState } from "react";
import ConfirmationDialog from "./ConfirmationDialog";
import { useGlobalState } from "../contexts/GlobalStateContext";

const UpdateEmailModal = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [notice, setNotice] = useState("");
  const [isError, setIsError] = useState(false); // ✅ New: track if notice is error
  const [showConfirm, setShowConfirm] = useState(false);
  const [step, setStep] = useState("enter"); // 'enter' or 'verify'
  const { logOut, resetGlobalState } = useGlobalState();
  const handlePreConfirm = () => {
    setNotice("");
    setIsError(false);

    if (!email.trim() || !password.trim()) {
      setNotice("Please enter both email and password.");
      setIsError(true); // ⚡ Error
      return;
    }
    setShowConfirm(true);
  };

  const updateEmail = () => {
    fetch("/php/updateEmail.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email.trim(),
        password: password.trim(),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setNotice(
            "A verification code has been sent to your new email address."
          );
          setIsError(false); // ✅ Success
          setStep("verify");
          setEmail("");
          setPassword("");
          setVerificationCode("");
        } else if (data.status === "error") {
          logOut();
          resetGlobalState();
        } else {
          setNotice(data.message);
          setIsError(true); // ⚡ Error
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setNotice("An error occurred while processing your request.");
        setIsError(true); // ⚡ Error
      });
  };

  const confirmCode = () => {
    const trimmedCode = verificationCode.trim();

    if (!trimmedCode) {
      setNotice("Please enter the verification code.");
      setIsError(true); // ⚡ Error
      return;
    }

    fetch("/php/confirm_email.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ code: trimmedCode }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setNotice("Your email address has been updated successfully.");
          setIsError(false); // ✅ Success
          setTimeout(() => {
            onClose();
          }, 2000);
        } else if (data.status === "error") {
          logOut();
          resetGlobalState();
        } else {
          setNotice(data.message);
          setIsError(true); // ⚡ Error
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setNotice("An error occurred while processing your request.");
        setIsError(true); // ⚡ Error
      });
  };

  const handleConfirmClick = () => {
    if (step === "enter") {
      handlePreConfirm();
    } else {
      confirmCode();
    }
  };

  return (
    <>
      <div className="update-setting-modal" style={{ display: "block" }}>
        <div className="setting-content">
          <div id="comments-header">
            <span id="modal-title">Update Email Address</span>
            <span className="close" onClick={onClose}>
              &times;
            </span>
          </div>

          {notice && (
            <div
              className="notice"
              style={{
                color: isError ? "red" : "green",
                margin: "10px",
                fontSize: "14px",
              }}
            >
              {notice}
            </div>
          )}

          {step === "enter" && (
            <>
              <input
                type="email"
                className="fullTextbox"
                placeholder="Enter New Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="new-email"
              />
              <input
                type="password"
                className="fullTextbox"
                placeholder="Enter Your Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
              />
            </>
          )}

          {step === "verify" && (
            <input
              type="number"
              className="fullTextbox"
              placeholder="Enter Verification Code"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              autoComplete="one-time-code"
            />
          )}

          <button
            style={{ backgroundColor: "#3DDC84" }}
            className="confirm"
            onClick={handleConfirmClick}
          >
            {step === "verify" ? "Confirm Code" : "Confirm"}
          </button>
        </div>
      </div>

      <ConfirmationDialog
        show={showConfirm}
        action="save"
        onConfirm={() => {
          setShowConfirm(false);
          updateEmail();
        }}
        onCancel={() => setShowConfirm(false)}
      />
    </>
  );
};

export default UpdateEmailModal;
